// extracted by mini-css-extract-plugin
export var color_picker_scheme_wrapper = "color_picker_scheme-module--color_picker_scheme_wrapper--79540";
export var grid_colors = "color_picker_scheme-module--grid_colors--ce777";
export var react_colorful = "color_picker_scheme-module--react_colorful--263d2";
export var react_colorful_input = "color_picker_scheme-module--react_colorful_input--80750";
export var react_colorful_last_control = "color_picker_scheme-module--react_colorful_last_control--42971";
export var title_card = "color_picker_scheme-module--title_card--144d3";